import {type JSX} from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "../auth/AuthContext";
import {type UserRole} from "../../util/userRole";

const ProtectedRoute = ({children, requiredRole}: {children: JSX.Element; requiredRole?: UserRole}) => {
    const {isAuthenticated, role, status} = useAuth();

    if (status === "checking") {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole && role !== requiredRole) {
        return <Navigate to="/access-denied" replace />;
    }

    return children;
};

export default ProtectedRoute;
